import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconLinkSvg } from "./IconLinkSvg.mjs";
const IconLink = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconLinkSvg, ...svgProps }) });
export {
  IconLink
};
